var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardetailCarService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 151.844,
    height: 151.844,
    rx: 75.922,
    fill: "#EFF8F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.4022 92.3906H69.627V95.0603H83.4022V92.3906Z",
    fill: "#09081A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.783 95.0533H100.739V92.384H103.783C104.69 92.384 105.438 91.6365 105.438 90.729V78.9571C105.438 78.103 104.771 77.4623 103.916 77.4623H56.3438V74.793H103.916C106.212 74.793 108.108 76.6615 108.108 78.9571V90.729C108.108 93.1314 106.159 95.0533 103.783 95.0533Z",
    fill: "#09081A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.833 95.0483H53.3358C51.2802 95.0483 49.625 93.3933 49.625 91.3379V67.6875H52.2946V91.3379C52.2946 91.9252 52.7484 92.379 53.3358 92.379H56.833V95.0483Z",
    fill: "#09081A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7083 77.4647H56.3438V74.7953H92.0098L85.7896 64.2781C85.4959 63.7709 84.9353 63.4506 84.3213 63.4506H73.9098V60.7812H84.348C85.8964 60.7812 87.338 61.6087 88.1122 62.9167L96.7083 77.4647Z",
    fill: "#09081A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2419 100.99C58.9705 100.99 55.5 97.5199 55.5 93.2489C55.5 88.978 58.9705 85.5078 63.2419 85.5078C67.5133 85.5078 70.9838 88.978 70.9838 93.2489C70.9838 97.5199 67.5133 100.99 63.2419 100.99ZM63.2419 88.1772C60.4388 88.1772 58.1696 90.4461 58.1696 93.2489C58.1696 96.0517 60.4388 98.3207 63.2419 98.3207C66.045 98.3207 68.3142 96.0517 68.3142 93.2489C68.3142 90.4461 66.045 88.1772 63.2419 88.1772Z",
    fill: "#09081A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3493 100.99C90.0779 100.99 86.6074 97.5199 86.6074 93.2489C86.6074 88.978 90.0779 85.5078 94.3493 85.5078C98.6207 85.5078 102.091 88.978 102.091 93.2489C102.118 97.5199 98.6207 100.99 94.3493 100.99ZM94.3493 88.1772C91.5462 88.1772 89.277 90.4461 89.277 93.2489C89.277 96.0517 91.5462 98.3207 94.3493 98.3207C97.1524 98.3207 99.4216 96.0517 99.4216 93.2489C99.4216 90.4461 97.1524 88.1772 94.3493 88.1772Z",
    fill: "#09081A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3025 86.6749H47.2569C45.4683 86.6749 44 85.2068 44 83.4183V74.1824C44 72.3939 45.4683 70.9258 47.2569 70.9258H52.3025V86.6749ZM47.2569 73.5951C46.9366 73.5951 46.6696 73.8621 46.6696 74.1824V83.4183C46.6696 83.7386 46.9366 84.0056 47.2569 84.0056H49.6329V73.5951H47.2569Z",
    fill: "#09081A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3395 62.1133H75.6699V76.1274H78.3395V62.1133Z",
    fill: "#09081A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8786 69.4609H62.209V76.1352H64.8786V69.4609Z",
    fill: "#09081A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.757 79.5977H100.777V82.2674H106.757V79.5977Z",
    fill: "#09081A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6706 68.3342C68.3253 68.3342 75.3413 61.3189 75.3413 52.6652C75.3413 44.0114 68.3253 36.9961 59.6706 36.9961C51.016 36.9961 44 44.0114 44 52.6652C44 61.3189 51.016 68.3342 59.6706 68.3342Z",
    fill: "#05D484"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6565 64.5371C53.0892 64.5371 47.75 59.1984 47.75 52.6318C47.75 46.0653 53.0892 40.7266 59.6565 40.7266C66.2237 40.7266 71.563 46.0653 71.563 52.6318C71.563 55.6749 70.8956 57.7303 69.2404 59.7056L67.1848 57.9972C68.4395 56.5024 68.8934 55.1143 68.8934 52.6585C68.8934 47.5601 64.7554 43.4226 59.6565 43.4226C54.5575 43.4226 50.4463 47.5601 50.4463 52.6585C50.4463 57.757 54.5842 61.8945 59.6832 61.8945C60.7243 61.8945 61.7388 61.7343 62.7265 61.3873L63.6075 63.8965C62.3261 64.3236 61.018 64.5371 59.6565 64.5371Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6922 56.6767L54.4375 54.3277L59.0826 51.8452V45.4922H61.7522V53.4468L55.6922 56.6767Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4824 55.5273L67.8973 61.2139L72.8094 57.4762L66.4824 55.5273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardetailCarService);
export default __webpack_public_path__ + "static/media/CardetailCarService.22c8cf08.svg";
export { ForwardRef as ReactComponent };